import React, { Component } from "react";

const RightArrow = ({width,height,fill}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 8 13"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7.0146 6.53199L2.02101 12.145L0.904486 10.8871L5.89807 5.27405L7.0146 6.53199Z"
        fill={fill}
      />
      <path
        d="M5.89795 7.56201L0.904361 1.949L2.02088 0.691055L7.01447 6.30407L5.89795 7.56201Z"
        fill={fill}
      />
    </svg>
  );
};

RightArrow.defaultProps = {
    width: 8,
    height:13,
    fill:'black'
}

export default RightArrow;
